import { render, staticRenderFns } from "./PrimaryTitle.vue?vue&type=template&id=6faab202&"
import script from "./PrimaryTitle.vue?vue&type=script&lang=js&"
export * from "./PrimaryTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports